<template>
  <v-form class="ml-2" @submit.prevent="loadData">
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-subheader light class="pa-0 mb-0 mx-0 form-subheader"
        >Zone commerciale
        </v-subheader>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="pt-0">
        <smart-multi-select
            :default-select-all="false"
            :items="marketingAreas"
            style="margin-top: 22px"
            item-text="name"
            allIsSameAsEmpty
            label="Zones"
            returnObject
            v-model="searchform.marketingAreaIds"
        >
        </smart-multi-select>
      </v-col>
      <v-col cols="12" class="mt-2">
        <v-subheader light class="pa-0 mb-0 mx-0 form-subheader"
        >Dates de Création
        </v-subheader
        >
        <v-divider></v-divider>
      </v-col>
      <v-col class="pr-1" cols="6">
        <smart-picker
            v-model="searchform.creationDateMin"
            :stopDate="searchform.creationDateMax"
            :inputOpts="{
                label: $t('begin'),
                clearable: true,
                placeholder: ' ',
              }"
        ></smart-picker>
      </v-col>
      <v-col cols="6" class="pr-1">
        <smart-picker
            v-model="searchform.creationDateMax"
            :startDate="searchform.creationDateMin"
            :inputOpts="{
                label: $t('end'),
                clearable: true,
                placeholder: ' ',
              }"
        ></smart-picker>
      </v-col>
      <v-col cols="12">
        <smart-btn type="submit" :loading="loading" block primary
        >Rechercher
        </smart-btn
        >
        <smart-btn
            class="mt-1"
            @click.native="clearSearchForm()"
            block
            tertiary
        >Réinitialiser la recherche
        </smart-btn
        >
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import {get} from "@/utils/api";
import {EventBus} from "@/components/commons/event-bus";
import SmartMultiSelect from "@/components/commons/SmartMultiSelect.vue";

export default {
  name: "CommercialNotVisitedDrawer",
  components: {SmartMultiSelect},
  data() {
    return {
      searchform: {
        marketingAreaIds: [],
        creationDateMin: null,
        creationDateMax: null
      },
      marketingAreas: [],
      loading: false
    }
  },
  mounted() {
    this.init()
  },

  computed:{
    filterMarketingAreas(){
      // All Marketing Areas without Italy
      return this.marketingAreas.filter(ma => ma.id != 4)
    }
  },

  methods: {
    async init() {
      await this.loadMarketingAreas()
      this.loadData()
    },

    loadMarketingAreas() {
      const url = "/api/search/marketingarea";
      return get(url)
          .json((data) => {
            this.marketingAreas = data;
            this.searchform.marketingAreaIds = this.filterMarketingAreas
          })

    },
    clearSearchForm() {
      this.searchform = {
        marketingAreaIds: this.filterMarketingAreas,
        creationDateMin: null,
        creationDateMax: null
      }
      this.loadData()
    },

    loadData() {
      EventBus.$emit("loading-not-visited", this.searchform)
    },
  }
}
</script>

